type FreestarPTLShortPlacementId =
	| 'incontent_reusable'
	| 'leaderboard_atf'
	| 'incontent_728_reusable'
	| 'incontent_970_reusable'
	| 'siderail_right_team_leagues';

export type FreestarPTLPlacementId =
	| 'pickleballteamleagues-com_incontent_reusable'
	| 'pickleballteamleagues-com_leaderboard_atf'
	| 'pickleballteamleagues-com_incontent_728_reusable'
	| 'pickleballteamleagues-com_incontent_970_reusable'
	| 'pickleballteamleagues-com_siderail_right_team_leagues';

export const PLACEMENT_IDS_PTL: Record<FreestarPTLShortPlacementId, FreestarPTLPlacementId> = {
	incontent_reusable: 'pickleballteamleagues-com_incontent_reusable',
	leaderboard_atf: 'pickleballteamleagues-com_leaderboard_atf',
	incontent_728_reusable: 'pickleballteamleagues-com_incontent_728_reusable',
	incontent_970_reusable: 'pickleballteamleagues-com_incontent_970_reusable',
	siderail_right_team_leagues: 'pickleballteamleagues-com_siderail_right_team_leagues'
};
